import { useMemo } from 'react'

import type { OwnStore } from '@krp/resource-own-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'

/** Срез `own` и dispatch приложения в форме, которую хуки пакета берут у приложения (пакет store не знает). */
export function useOwnStore(): OwnStore {
  const state = useAppSelector((root) => root.own)
  const dispatch = useAppDispatch()
  return useMemo(() => ({ state, dispatch }), [state, dispatch])
}
